/**
 * Номер заявки для файла КП из сохранённого снимка.
 *
 * Номер пишется в снимок один раз при выставлении КП. 14.09.2026 заявки из-за
 * сбоя уходили в «Новую» без номера, и их КП навсегда сохранили пустой номер:
 * перекачивание и «Пересчитать КП» выпускали файл с «—». Если в снимке номера
 * нет — берём текущий номер заявки.
 */
export function kpRequestNumber(
  snapshotNumber: string | null | undefined,
  currentNumber: string | null | undefined,
): string | undefined {
  return snapshotNumber?.trim() || currentNumber?.trim() || undefined
}
